<template>
  <v-card flat color="grey-lighten-4">
    <v-card-title>
      {{ $t('components.ImageEditor.title') }}
    </v-card-title>
    <v-divider class="my-2"/>
    <v-card-text>

      <configuration-section-row>
        <template #name>
          {{ $t('components.ImageEditor.favicon') }}
        </template>
        <template #comment>
          <b>File type: </b> ico <br/>
          <b>Recommended Size: </b> 32x32px
        </template>

        <image-uploader
          configurationKey="favicon"
        />
      </configuration-section-row>

      <configuration-section-row>
        <template #name>
          {{ $t('components.ImageEditor.logo') }}
        </template>
        <template #comment>
          <b>File type: </b> png <br/>
          <b>Recommended Size: </b> 368x85px
        </template>
        <image-uploader
          configurationKey="logo"
          :label="$t('components.ImageEditor.logo')"
        />
      </configuration-section-row>

      <configuration-section-row>
        <template #name>
          {{ $t('components.ImageEditor.light_logo') }}
        </template>
        <template #comment>
          Used on dark backgrounds. <br />
          <b>File type: </b> png <br/>
          <b>Recommended Size: </b> 368x85px
        </template>
        <image-uploader
          configurationKey="logoLight"
          :label="$t('components.ImageEditor.logo')"
        />
      </configuration-section-row>

      <configuration-section-row>
        <template #name>
          {{ $t('components.ImageEditor.app_icon') }}
        </template>
        <template #comment>
          <b>File type: </b> png <br/>
          <b>Recommended Size: </b> 120x120px
        </template>
        <image-uploader
          configurationKey="appIcon"
          :label="$t('components.ImageEditor.logo')"
        />
      </configuration-section-row>

      <configuration-section-row>
        <template #name>
          {{ $t('components.ImageEditor.light_app_icon') }}
        </template>
        <template #comment>
          <b>File type: </b> png <br/>
          <b>Recommended Size: </b> 120x120px
        </template>
        <image-uploader
          configurationKey="appIconLight"
          :label="$t('components.ImageEditor.light_app_icon')"
        />
      </configuration-section-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import ImageUploader from "@/pages/Settings/AppConfigurationPage/components/ImageUploader.vue";
import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";
</script>
